import React, { useState } from 'react';
import { LockIcon, LogOutIcon } from 'lucide-react';
import { useStore } from '../contexts/StoreContext';
import { LeadsPanel } from '../components/admin/LeadsPanel';
import { VehiclesPanel } from '../components/admin/VehiclesPanel';
import { BrandsPanel } from '../components/admin/BrandsPanel';
import { BannersPanel } from '../components/admin/BannersPanel';
import { HistoryPanel } from '../components/admin/HistoryPanel';
import { SettingsPanel } from '../components/admin/SettingsPanel';
type Tab = 'consultas' | 'unidades' | 'marcas' | 'banners' | 'historial' | 'ajustes';
const tabs: {
  id: Tab;
  label: string;
}[] = [{
  id: 'consultas',
  label: 'Consultas'
}, {
  id: 'unidades',
  label: 'Unidades'
}, {
  id: 'marcas',
  label: 'Marcas y condiciones'
}, {
  id: 'banners',
  label: 'Banners'
}, {
  id: 'historial',
  label: 'Historial'
}, {
  id: 'ajustes',
  label: 'Ajustes'
}];
const SESSION_KEY = 'vcars-admin-session';
export function Admin() {
  const {
    settings,
    leads
  } = useStore();
  const [authed, setAuthed] = useState(() => sessionStorage.getItem(SESSION_KEY) === '1');
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [tab, setTab] = useState<Tab>('consultas');
  if (!authed) {
    return <div className="container-x grid min-h-[70vh] place-items-center py-12" data-id="element-1128" data-mp="3boy4ysqb35ae">
        <form onSubmit={e => {
        e.preventDefault();
        if (pin === settings.adminPin) {
          sessionStorage.setItem(SESSION_KEY, '1');
          setAuthed(true);
        } else {
          setError('Clave incorrecta.');
        }
      }} className="card w-full max-w-sm p-6" data-id="element-1129" data-mp="36nqwergca22o">
          <LockIcon className="h-6 w-6 text-neon" aria-hidden data-id="element-1130" data-mp="2nyc2ri2zgf8b" />
          <h1 className="mt-3 font-display text-xl font-bold" data-id="element-1131" data-mp="2iyg663wm7q2s">Panel de administración</h1>
          <p className="mt-1 text-sm text-mist" data-id="element-1132" data-mp="2j0afsm2frvrk">Acceso restringido. Ingresá la clave del panel.</p>
          <label htmlFor="adm-pin" className="label mt-5" data-id="element-1133" data-mp="2e1phis6qvm5r">Clave</label>
          <input id="adm-pin" type="password" className="input" value={pin} onChange={e => setPin(e.target.value)} autoComplete="current-password" autoFocus data-id="element-1134" data-mp="24a64prdpyroi" />
          {error && <p className="mt-2 text-xs text-danger" role="alert" data-id="element-1135" data-mp="1uecq82gfwo43">{error}</p>}
          <button type="submit" className="btn btn-primary mt-4 w-full" data-id="element-1136" data-mp="1zcea2plowrgm">Ingresar</button>
        </form>
      </div>;
  }
  const newLeads = leads.filter(l => l.status === 'recibida').length;
  return <div className="container-x py-8" data-id="element-1137" data-mp="2s1v0xitnw0aq">
      <div className="flex items-center justify-between gap-4" data-id="element-1138" data-mp="2s0scdhjta9xz">
        <h1 className="font-display text-2xl font-black tracking-tight sm:text-3xl" data-id="element-1139" data-mp="2dd78vmj0y8pj">Administración</h1>
        <button onClick={() => {
        sessionStorage.removeItem(SESSION_KEY);
        setAuthed(false);
        setPin('');
      }} className="btn btn-ghost h-9" data-id="element-1140" data-mp="2iaqkeeoc87ds">
          <LogOutIcon className="h-4 w-4" aria-hidden data-id="element-1141" data-mp="3asusmrsjjo7p" /> Salir
        </button>
      </div>

      <div className="-mx-4 mt-6 overflow-x-auto px-4 sm:mx-0 sm:px-0" data-id="element-1142" data-mp="zc2jvyab0b1j">
        <div role="tablist" aria-label="Secciones del panel" className="flex min-w-max gap-1 border-b border-line" data-id="element-1143" data-mp="ue0wx29rbrks">
          {tabs.map(t => <button key={t.id} role="tab" aria-selected={tab === t.id} onClick={() => setTab(t.id)} className={`relative px-4 py-3 text-sm font-medium transition-colors duration-150 ${tab === t.id ? 'text-white' : 'text-mist hover:text-white'}`} data-id="element-1144" data-mp="192460kj3jjdt">
              {t.label}
              {t.id === 'consultas' && newLeads > 0 && <span className="ml-1.5 rounded-full bg-neon px-1.5 py-0.5 text-[10px] font-bold text-white" data-id="element-1145" data-mp="pfg07ctprq13">{newLeads}</span>}
              {tab === t.id && <span className="absolute inset-x-2 -bottom-px h-0.5 bg-neon" aria-hidden data-id="element-1146" data-mp="20tthfytyp785" />}
            </button>)}
        </div>
      </div>

      <div className="mt-6" role="tabpanel" data-id="element-1147" data-mp="1wrgbb9baz7au">
        {tab === 'consultas' && <LeadsPanel data-id="element-1148" data-mp="2s2wl9lta7fbg" />}
        {tab === 'unidades' && <VehiclesPanel data-id="element-1149" data-mp="2s3zfa2lwhxvl" />}
        {tab === 'marcas' && <BrandsPanel data-id="element-1150" data-mp="2w3q80buzmo2r" />}
        {tab === 'banners' && <BannersPanel data-id="element-1151" data-mp="2w4i55r48gtv5" />}
        {tab === 'historial' && <HistoryPanel data-id="element-1152" data-mp="313clmmeqa6c3" />}
        {tab === 'ajustes' && <SettingsPanel data-id="element-1153" data-mp="311i1haba6i92" />}
      </div>
    </div>;
}